import styles from './partner-display-page.module.scss';
import PartnerInfo from '../partner-info';
import RelatedPartnersCarousel from '../related-partners-carousel';
import { PartnerPageProperties } from './partner-display-page.types';

const PartnerPage = ({
  shopNowButtonProperties,
  partnerInfoProperties,
  relatedPartnersCarouselProperties,
  promotionalBannerProperties,
  setShowError,
}: PartnerPageProperties) => {
  return (
    <div className={styles.pdp}>
      <PartnerInfo
        {...partnerInfoProperties}
        {...shopNowButtonProperties}
        partnerPromotionalBannerProperties={promotionalBannerProperties}
        setShowError={setShowError}
      />
      <RelatedPartnersCarousel {...relatedPartnersCarouselProperties} />
    </div>
  );
};

export default PartnerPage;
